import CoreServices from './coreServices'
import { USERS } from '../constants/services'
import axios from 'axios'

class StoryService extends CoreServices {
  async all(page) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.get(`${this.apiEnpointV1}/stories?page=${page}`, {
        headers: headers
      })

      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async public(queries = {}) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.get(`${this.apiEnpointV1}/stories/public`, {
        headers: headers,
        params: queries
      })

      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async modelPublic(uid) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.get(`${this.apiEnpointV1}/stories/${uid}/model`, {
        headers: headers
      })

      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async view(storyId) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.get(`${this.apiEnpointV1}/stories/${storyId}/view?device=web`, {
        headers: headers
      })

      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async getStoryByUid(uid) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.get(`${this.apiEnpointV1}/stories/${uid}/uid`, {
        headers: headers
      })

      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async like(storyId, isLike) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.post(`${this.apiEnpointV1}/stories/${storyId}/like`, { isLike: isLike })
      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async upload(args) {
    let headers = {
    }

    try {
      let res = await axios.post(`${this.apiEnpointV1}/stories`,
        args, {
        headers: headers
      })

      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }

  async destroy(storyId) {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  
    try {
      let res = await axios.delete(`${this.apiEnpointV1}/stories/${storyId}`, {
        headers: headers
      })
  
      let data = await res.data
  
      return data
    } catch (error) {
      return { error }
    }
  }

  async isAllowCreate() {
    let headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }

    try {
      let res = await axios.get(`${this.apiEnpointV1}/stories/allow-create`, {
        headers: headers
      })
  
      let data = await res.data.data

      return data
    } catch (error) {
      return { error }
    }
  }
}

export default new StoryService(USERS.BASE)
